<div class="adx-lib-panel-wrapper">
  <div class="adx-osm-map-container">
    <div class="adx-osm-map" #mapContainer [id]="'map_' + appPluginWidget?._id">
      @if (isVesselSidePanelActive) {
        <lib-map-sidepanel-content
          [widgetId]="appPluginWidget?._id"
          [vesselItems]="vesselItems$ | async"
        (selectedVesselItem)="leafletService.centerOnSelectedMarker(
        $event,
        leafletInstance,
        appPluginWidget?.settings
        )"
          >
        </lib-map-sidepanel-content>
      }
    </div>
  </div>
</div>
